export const SPONSOR_TYPES = () => ({
  HOMEPAGE: 'HOMEPAGE',
  LISTING: 'LISTING',
});

export const SPONSOR_STATUSES = () => ({
  ARCHIVED: 'ARCHIVED',
  LIVE: 'LIVE',
  SCHEDULED: 'SCHEDULED',
  DELETED: 'DELETED',
});



// WEBPACK FOOTER //
// ./src/app/sponsors/sponsors.constants.js